<h2 mat-dialog-title mat-dialog-draggable-title>
  {{'change_password.screen_name' | translate}}
  <button type="button" class="close" aria-label="Close" cdkFocusInitial (click)="cancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</h2>
<mat-divider></mat-divider>
<form name="form" #f="ngForm" (ngSubmit)="f.form.valid && changePassword()"
  [notMatch]="['currentPassword', 'newPassword']" [mustMatch]="['newPassword', 'confirmPassword']" appFocusFirstElement>
  <mat-dialog-content>
    <div class="row mt-2">
      <div class="col-12">
        <mat-form-field class="w-100">
          <button matSuffix mat-icon-button color="primary" type="button" (click)="currentPasswordVisibility = !currentPasswordVisibility">
            <mat-icon>{{!currentPasswordVisibility ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          <input matInput [type]="currentPasswordVisibility ? 'text' : 'password'" #focusInput [placeholder]="'change_password.lbl_current_password' | translate"
            name="currentPassword" id="currentPassword" [(ngModel)]="passwordData.currentPassword"
            #currentPass="ngModel" required maxlength="100" autocomplete="off" />
          <mat-error *ngIf="f.submitted || currentPass?.errors?.required">
            <span class="text-error">{{'change_password.validation.current_pass_required' | translate}}</span>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-12">
        <!-- <mat-form-field class="w-100">
            <button matSuffix mat-icon-button color="primary" type="button" (click)="newPasswordVisibility = !newPasswordVisibility">
                <mat-icon>{{!newPasswordVisibility ? 'visibility_off' : 'visibility'}}</mat-icon>
              </button>
          <input matInput [type]="newPasswordVisibility ? 'text' : 'password'" [placeholder]="'change_password.lbl_new_password' | translate"
            name="newPassword" id="newPassword" [(ngModel)]="passwordData.newPassword" #newPass="ngModel" required
            [pattern]="strengthPattern"
            passwordPattern
            maxlength="100" (focusout)="passwordData.newPassword = passwordData.newPassword.trim()" autocomplete="off" />
          <mat-error *ngIf="newPass?.errors?.required">
            <span class="text-error">{{'change_password.validation.new_pass_required' | translate}}</span>
          </mat-error>
          <mat-error *ngIf="newPass?.errors?.notMatch">
            <span class="text-error">{{'change_password.validation.not_match' | translate}}</span>
          </mat-error>
          <mat-error *ngIf="newPass?.errors?.pattern">
            <span class="text-error">{{'change_password.validation.strength' | translate}}</span>
          </mat-error>
        </mat-form-field> -->

        <mat-form-field class="w-100">
          <button matSuffix mat-icon-button color="primary" type="button" (click)="clickVisibility()">
            <mat-icon>{{!newPasswordVisibility ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          <input #focusInput matInput [type]="newPasswordVisibility ? 'text' : 'password'" [placeholder]="'change_password.lbl_new_password' | translate"
                 name="newPassword" id="newPassword" [(ngModel)]="passwordData.newPassword" #newPass="ngModel" required
                 [pattern]="strengthPattern"
                 passwordPattern
                 (focus)="onFocus()"
                 (blur)="onBlur()"
                 minlength="8"
                 maxlength="100" (focusout)="passwordData.newPassword = passwordData.newPassword.trim()" autocomplete="off" />

         <!-- validate new password -->
          <mat-hint *ngIf="isTouch && ((!isFocusNewPassword && newPass.invalid) || isFocusNewPassword)" class="line-hint">
            <div class="line-warning">
              <mat-icon class="hint-icon green-icon" color="primary" *ngIf="!newPass?.errors?.pattern && !newPass?.errors?.required && newPass.dirty">check_circle_outline</mat-icon>
              <mat-icon class="hint-icon" color="warn" *ngIf="(newPass?.errors?.pattern || newPass?.errors?.required) && newPass.dirty">highlight_off</mat-icon>
              <mat-icon class="hint-icon" *ngIf="!newPass.dirty">check_circle_outline</mat-icon>
              <span style="padding-left: 5px" [ngClass]="!newPass.dirty? 'text-primary' : !newPass?.errors?.pattern && !newPass?.errors?.required ? 'text-primary green-icon' : 'text-warn'">{{'change_password.validation.strength' | translate}}</span>
            </div>
          </mat-hint>
          <div></div>
          <!-- minlength=8 -->
          <mat-hint *ngIf="isTouch && ((!isFocusNewPassword && newPass.invalid) || isFocusNewPassword)">
            <div class="line-warning">
              <mat-icon class="hint-icon green-icon" color="primary" *ngIf="!newPass?.errors?.minlength && !newPass?.errors?.required && newPass.dirty">check_circle_outline</mat-icon>
              <mat-icon class="hint-icon" color="warn" *ngIf="(newPass?.errors?.minlength || newPass?.errors?.required) && newPass.dirty">highlight_off</mat-icon>
              <mat-icon class="hint-icon" *ngIf="!newPass.dirty">check_circle_outline</mat-icon>
              <span style="padding-left: 5px" [ngClass]="!newPass.dirty? 'text-primary' : !newPass?.errors?.minlength && !newPass?.errors?.required ?  'text-primary green-icon'  : 'text-warn'">{{'change_password.validation.at_least_8_letter' | translate}}</span>
            </div>
          </mat-hint>

          <!-- minlength=8 -->
          <mat-hint *ngIf="isTouch && ((!isFocusNewPassword && newPass.invalid) || isFocusNewPassword)">
            <div class="line-warning">
              <mat-icon class="hint-icon green-icon" color="primary" *ngIf="!newPass?.errors?.invalidContainPattern && !newPass?.errors?.required && newPass.dirty">check_circle_outline</mat-icon>
              <mat-icon class="hint-icon" color="warn" *ngIf="(newPass?.errors?.invalidContainPattern || newPass?.errors?.required) && newPass.dirty">highlight_off</mat-icon>
              <mat-icon class="hint-icon" *ngIf="!newPass.dirty">check_circle_outline</mat-icon>
              <span style="padding-left: 5px" [ngClass]="!newPass.dirty? 'text-primary' : !newPass?.errors?.invalidContainPattern && !newPass?.errors?.required ?  'text-primary green-icon' : 'text-warn'">{{'change_password.validation.not_contain' | translate}}</span>
            </div>
          </mat-hint>



        <!-- end validate new password -->

          <!-- <mat-error *ngIf="newPass?.errors?.required">
            <span class="text-error">{{'change_password.validation.new_pass_required' | translate}}</span>
          </mat-error>
          <mat-error *ngIf="newPass?.errors?.notMatch">
            <span class="text-error">{{'change_password.validation.not_match' | translate}}</span>
          </mat-error> -->
          <!-- <mat-error *ngIf="newPass?.errors?.pattern">
            <span class="text-error">{{'change_password.validation.strength' | translate}}</span>
          </mat-error> -->
        </mat-form-field>


      </div>
    </div>
    <div class="row mt-2">
      <div class="col-12">
        <mat-form-field class="w-100">
            <button matSuffix mat-icon-button color="primary" type="button" (click)="confirmPasswordVisibility = !confirmPasswordVisibility">
                <mat-icon>{{!confirmPasswordVisibility ? 'visibility_off' : 'visibility'}}</mat-icon>
              </button>
          <input matInput [type]="confirmPasswordVisibility ? 'text' : 'password'" [placeholder]="'change_password.lbl_new_password_confirm' | translate"
            name="confirmPassword" id="confirmPassword" [(ngModel)]="passwordData.confirmPassword"
            #confirmPass="ngModel" required maxlength="100" (focusout)="passwordData.confirmPassword = passwordData.confirmPassword.trim()" autocomplete="off"/>
          <mat-error *ngIf="confirmPass?.errors?.required">
            <span class="text-error">{{'change_password.validation.confirm_pass_required' | translate}}</span>
          </mat-error>
          <mat-error *ngIf="confirmPass?.errors?.mustMatch">
            <span class="text-error">{{'change_password.validation.must_match' | translate}}</span>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="center" class="mt-2">
    <button mat-stroked-button color="primary" class="mr-3" type="button" (click)="cancel()">
      <mat-icon class="mr-0">cancel</mat-icon>{{'enterprise_document_template_add_pop.buttons.cancel' | translate}}
    </button>
    <button mat-raised-button [disabled]="f.form.invalid" color="primary" type="submit" cdkFocusInitial>
      <mat-icon class="mr-0">save</mat-icon>{{'enterprise_document_template_add_pop.buttons.save' | translate}}
    </button>
  </mat-dialog-actions>
</form>
